// extracted by mini-css-extract-plugin
export default {"deal-container":"NREfGvyPk8hvbC4zQhpd","deal-content":"ZmStVwjmuD48wuWcGkYN","deal-item":"cxA4Fnlp_gRdaf9jSGyF","deal-title":"_MrSTBQLONB7o0LEEUle"};